import getGradYear from '../get-grad-year'
import GRADE_LEVELS from '../../constants/grade-levels'

const gradeNumber = (graduationYear) => {
    if (!graduationYear || isNaN(graduationYear)) {
        return 0
    }

    //  Student graduation year
    const gradYear = parseInt(graduationYear)

    const yearsToGraduate = gradYear - getGradYear()
    if (yearsToGraduate < 0) {
        return 0
    }
    if (yearsToGraduate > 3) {
        return 0
    }
    switch(yearsToGraduate){
    case GRADE_LEVELS.SENIOR: return 12
    case GRADE_LEVELS.JUNIOR: return 11
    case GRADE_LEVELS.SOPHOMORE: return 10
    case GRADE_LEVELS.FRESHMAN: return 9
    default: return 0
    }
}

export default gradeNumber